import { THINKING, type Thinking, thinkingFor } from "@rally/agreed";

export const A_FAIR_EFFORT: Thinking = "medium";

export function effortOffered(model: string | undefined, provider?: string): readonly Thinking[] {
  return model ? thinkingFor(model, provider) : [];
}

export function aFairEffortIn(offered: readonly Thinking[]): Thinking {
  if (offered.length === 0) return A_FAIR_EFFORT;
  if (offered.includes(A_FAIR_EFFORT)) return A_FAIR_EFFORT;
  const wanted = THINKING.indexOf(A_FAIR_EFFORT);
  const below = offered.filter((one) => THINKING.indexOf(one) < wanted);
  return below[below.length - 1] ?? offered[0] ?? A_FAIR_EFFORT;
}

export function effortSaid(said: string, offered: readonly Thinking[]): Thinking {
  const known = THINKING.find((one) => one === said);
  return known ?? aFairEffortIn(offered);
}
